"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _checkmark = _interopRequireDefault(require("@ux/icon/checkmark"));
var _CardStandard = _interopRequireDefault(require("./styles/CardStandard"));
var _cardStyling = _interopRequireDefault(require("./styles/cardStyling"));
const iconBackgroundMap = {
  black: 'card-icon-black-background',
  purple: 'card-icon-purple-background',
  tile: 'card-icon-tile-background'
};
const CardStandard = ({
  card,
  style
}) => {
  const Icon = card.iconComponent;
  const backgroundColor = iconBackgroundMap[card.iconColor];
  return /*#__PURE__*/_react.default.createElement(_cardStyling.default, {
    className: (0, _classnames.default)({
      'p-3': card.isMobile,
      'p-4': !card.isMobile
    }, card.containerClassName),
    style: {
      ...style
    },
    "data-testid": "cardStandard",
    "data-cy": "cardStandard",
    backgroundColor: card.backgroundColor
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(`${_CardStandard.default} card-body d-flex p-0 flex-column`, {
      'align-items-center': card.itemsCenter
    })
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center pb-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    className: `card-standard-icon p-2 ${backgroundColor}`
  })), /*#__PURE__*/_react.default.createElement("h6", {
    className: "font-weight-bold mb-0"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: card.title
  }))), card.description && /*#__PURE__*/_react.default.createElement("p", {
    className: card.descriptionClassName,
    "data-testid": "cardContainer"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: card.description
  })), card.rtbItemsArray?.map((item, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: index,
    className: "d-flex align-items-center pb-2"
  }, /*#__PURE__*/_react.default.createElement(_checkmark.default, null), /*#__PURE__*/_react.default.createElement("span", {
    className: "ml-3"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: item
  }))))), card.imageUrl && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "card-standard-media-container",
    className: `card-standard-media-container ${card.mediaContainerClassName}`
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "search-comparison-card-image",
    src: card.imageUrl,
    alt: card.title
  })), card?.customComponent));
};
CardStandard.propTypes = {
  style: _propTypes.default.object,
  card: _propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    description: _propTypes.default.string,
    iconColor: _propTypes.default.string.isRequired,
    rtbItemsArray: _propTypes.default.arrayOf(_propTypes.default.string),
    itemsCenter: _propTypes.default.bool,
    iconComponent: _propTypes.default.elementType.isRequired,
    isMobile: _propTypes.default.bool,
    containerClassName: _propTypes.default.string,
    descriptionClassName: _propTypes.default.string,
    mediaContainerClassName: _propTypes.default.string,
    imageUrl: _propTypes.default.string,
    customComponent: _propTypes.default.node,
    backgroundColor: _propTypes.default.string
  }).isRequired
};
var _default = exports.default = CardStandard;